export default "__VITE_ASSET__BZW38b1A__"